module.exports = __webpack_public_path__ + "fonts/58e6b98.otf";